import { BlogRootEntityTypes } from 'common/enums/blog-root-entity-types'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import ServerPageInterface from 'src/shared/types/server-page-interface'

/* NOTE: for fixing https://app.shortcut.com/systeme/story/51271/adding-masterblock-creates-duplicates-on-page-header-and-footer
 * Remove duplicated entities
 *
 * ------CASE 1-------
 * entities: {
 *  bodyEntity: {
 *    childIds: [entity1, entity2]
 *  },
 *  entity1: {
 *    parentId: bodyEntity,
 *    childIds: [entity2],
 *  },
 *  entity2: {
 *    parentId: entity1,
 *    childIds: [],
 *  },
 * }
 * bodyEntity childIds has entity2 and entity1 childIds has entity2. Entity2 parentId equals entity1,
 * therefore we have to remove entity2 from bodyEntity childIds
 * -------------------
 *
 * ------CASE 2-------
 * entities: {
 *  bodyEntity: {
 *    childIds: [entity1, entity1]
 *  },
 *  entity1: {
 *    parentId: bodyEntity,
 *    childIds: [],
 *  },
 * }
 * bodyEntity childIds has entity1 several times. We have remove duplicates
 * therefore we have to remove entity1 from bodyEntity childIds
 * -------------------
 */
export default function removeDuplicatedEntitiesCommand(
  page: ServerPageInterface,
): [ServerPageInterface, boolean] {
  let needChangeContent = false
  const originalEntities = page.content.entities

  // biome-ignore lint/complexity/noForEach: <explanation>
  Object.values(originalEntities).forEach(entity => {
    if ('childIds' in entity && entity.childIds) {
      const newChildIds = entity.childIds
        // resolve parentId and childIds conflict (CASE 1)
        .filter(childId => {
          if (
            ('parentId' in originalEntities[childId] &&
              originalEntities[childId].parentId === entity.id) ||
            BlogRootEntityTypes.includes(
              originalEntities[childId].type as EntityTypeEnum,
            )
          ) {
            return true
          } else {
            needChangeContent = true
            return false
          }
        })
        // remove duplicates (CASE 2)
        .filter((childId, index, filteredChildIds) => {
          if (filteredChildIds.indexOf(childId) === index) {
            return true
          } else {
            needChangeContent = true
            return false
          }
        })

      ;(originalEntities[entity.id] as typeof entity).childIds = newChildIds
    }
  })

  return [page, needChangeContent]
}
